import styled from 'styled-components';
import { colors } from '../../constants';

export const DividerLine = styled.div`
    background-color: ${colors.greyBorder};
    height: 1px;
    margin: 0.5rem 0 0.75rem;
`;
